import React from 'react';
import { cn } from '../../../lib/utils';

export interface TaskyLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  error?: boolean;
}

export const TaskyLabel = React.forwardRef<HTMLLabelElement, TaskyLabelProps>(
  ({ className, required, error, children, ...rest }, ref) => (
    <label
      ref={ref}
      {...rest}
      className={cn(
        'block text-sm font-medium mb-1.5',
        error ? 'text-destructive' : 'text-dark',
        className,
      )}
    >
      {children}
      {required && <span className="ml-1 text-destructive">*</span>}
    </label>
  ),
);
TaskyLabel.displayName = 'TaskyLabel';
